import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./Image.module.scss";
export const Image = ({ url, alt, className }) => {
    return (_jsx("div", { className: `${styles.container} ${className ? className : ""}`, style: { backgroundImage: `url(${url})` }, role: "img", "aria-label": alt }));
};
//# sourceMappingURL=Image.js.map